(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.vm')
      .service('CloneVmToTemplateService', CloneVmToTemplateService);

   CloneVmToTemplateService.$inject = [
      'vmProvisioningDatastorePageService',
      'vmProvisioningNameAndFolderPageService',
      'vmProvisioningFinishCloneVmPageService',
      'VmProvisioningComputeResourcePageService'
   ];

   function CloneVmToTemplateService(vmProvisioningDatastorePageService,
                                       vmProvisioningNameAndFolderPageService,
                                       vmProvisioningFinishCloneVmPageService,
                                       VmProvisioningComputeResourcePageService) {
      return function () {
         this.buildPages = buildPages;

         function buildPages(wizardScope, defaultTarget, preselectedComputeResource) {
            var namePage = vmProvisioningNameAndFolderPageService.build(wizardScope, defaultTarget);
            var computeResourcePage = VmProvisioningComputeResourcePageService.build(wizardScope, preselectedComputeResource);
            var datastorePage = vmProvisioningDatastorePageService.build(wizardScope);
            var finishCloneVmPage = vmProvisioningFinishCloneVmPageService.build(wizardScope);

            return {
               pages: [
                  namePage,
                  computeResourcePage,
                  datastorePage,
                  finishCloneVmPage
               ]
            };
         }
      };
   }
})();
